import React from 'react';
import { Quote, Star } from 'lucide-react';
import { testimonials } from '../../data/mock';

const TestimonialsSection = () => {
  return (
    <section className="relative bg-black py-24 lg:py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-b from-[#4A90A4]/5 via-transparent to-transparent" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-[#4A90A4] text-sm font-semibold uppercase tracking-wider mb-4 block">Testimonials</span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            What Our <span className="text-[#4A90A4]">Clients Say</span>
          </h2>
          <p className="text-white/60 text-lg">
            Trusted by businesses across Canada for over 15 years
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="group relative bg-white/[0.02] border border-white/10 p-8 hover:border-[#4A90A4]/30 hover:bg-[#4A90A4]/5 transition-all duration-500"
            >
              {/* Quote Icon */}
              <div className="absolute -top-4 left-8">
                <div className="w-8 h-8 bg-[#4A90A4] flex items-center justify-center">
                  <Quote size={16} className="text-white" />
                </div>
              </div>

              {/* Stars */}
              <div className="flex gap-1 mb-6 pt-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={16} className="fill-[#4A90A4] text-[#4A90A4]" />
                ))}
              </div>

              {/* Quote */}
              <p className="text-white/80 leading-relaxed mb-6">
                "{testimonial.quote}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-4 pt-6 border-t border-white/10">
                <div className="w-12 h-12 bg-gradient-to-br from-[#4A90A4] to-[#2D5A6B] flex items-center justify-center text-white font-bold">
                  {testimonial.author.charAt(0)}
                </div>
                <div>
                  <p className="text-white font-medium">{testimonial.author}</p>
                  <p className="text-white/40 text-sm">{testimonial.company}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Badges */}
        <div className="mt-20 text-center">
          <p className="text-white/40 text-sm uppercase tracking-wider mb-8">Trusted by leading Canadian companies</p>
          <div className="flex flex-wrap justify-center items-center gap-12 opacity-40">
            {['Manufacturing Co.', 'Tech Solutions', 'Food Processing Inc.', 'Industrial Systems', 'BioTech Labs'].map((company, i) => (
              <div key={i} className="text-white font-semibold text-lg">
                {company}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
